import { useEffect, useMemo } from 'react';
import { selectKnowledgeBase } from '../knowledge-base/selectors/knowledgeBaseDetails';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import OnboardingStart from '../components/OnboardingStart';
import { KB_ONBOARDING_PATH } from '../routing/constants/RouteConstants';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useFetchKnowledgeBases } from '../knowledge-base/queries/KnowledgeBasesQuery';
import { FETCH_KNOWLEDGE_BASE_SUCCESS } from '../actions/ActionTypes';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useAppDispatch, useAppSelector } from '../utils/hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StageKnowledgeBase = ({
  children,
  knowledgeBaseId
}) => {
  const {
    data: knowledgeBases,
    error: knowledgeBasesError,
    loading: loadingKnowledgeBases
  } = useFetchKnowledgeBases({
    includeVariants: true
  });
  const dispatch = useAppDispatch();
  const history = useHistory();
  const currentKnowledgeBaseId = useAppSelector(state => {
    const knowledgeBase = selectKnowledgeBase(state);
    return knowledgeBase ? knowledgeBase.id : null;
  });
  const {
    knowledgeBaseId: knowledgeBaseIdString
  } = useParams();
  const knowledgeBaseIdToStage = knowledgeBaseId || (knowledgeBaseIdString ? parseInt(knowledgeBaseIdString, 10) : undefined);
  const defaultKnowledgeBaseId = knowledgeBases && knowledgeBases[0] && knowledgeBases[0].id;
  const currentKnowledgeBase = useMemo(() => knowledgeBases && knowledgeBases.find(({
    id
  }) => id === knowledgeBaseIdToStage), [knowledgeBases, knowledgeBaseIdToStage]);
  useEffect(() => {
    if (!loadingKnowledgeBases && knowledgeBaseIdToStage !== currentKnowledgeBaseId && knowledgeBases && knowledgeBases.find(({
      id
    }) => id === knowledgeBaseIdToStage)) {
      dispatch({
        type: FETCH_KNOWLEDGE_BASE_SUCCESS,
        payload: {
          requestedKnowledgeBaseId: knowledgeBaseIdToStage,
          knowledgeBases: {
            objects: knowledgeBases
          }
        }
      });
    }
  }, [dispatch, knowledgeBaseIdToStage, currentKnowledgeBaseId, loadingKnowledgeBases, knowledgeBases]);
  if (loadingKnowledgeBases || !knowledgeBaseIdToStage) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {});
  }

  // if we are loading a KB that is a translated variant of a primary KB, redirect to the primary KB.
  if (!loadingKnowledgeBases && currentKnowledgeBase && currentKnowledgeBase.scpValues && currentKnowledgeBase.scpValues.hs_translated_from_id) {
    const currentPath = history.location.pathname;
    return /*#__PURE__*/_jsx(Redirect, {
      from: currentPath,
      to: currentPath.replace(`${currentKnowledgeBase.id}`, `${currentKnowledgeBase.scpValues.hs_translated_from_id}`)
    });
  }
  if (!loadingKnowledgeBases && !currentKnowledgeBase && defaultKnowledgeBaseId) {
    return /*#__PURE__*/_jsx(UIErrorMessage, {
      type: "404",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "knowledgeContentUI.errors.notFound_jsx",
        elements: {
          br: () => /*#__PURE__*/_jsx("br", {}),
          UIButton
        },
        options: {
          onClick: () => history.push(history.location.pathname.replace(`${knowledgeBaseIdToStage}`, `${defaultKnowledgeBaseId}`)),
          use: 'link'
        }
      })
    });
  }
  if (!loadingKnowledgeBases && (!currentKnowledgeBase || knowledgeBasesError)) {
    return /*#__PURE__*/_jsx(UIErrorMessage, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.errors.general"
      })
    });
  }
  if (currentKnowledgeBaseId === null) {
    return /*#__PURE__*/_jsx(OnboardingStart, {
      isSetupDisabled: false,
      onClick: () => history.push(`${KB_ONBOARDING_PATH}?cancel=back`)
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default StageKnowledgeBase;